import React from 'react';
import Select from 'react-select';

import DeleteIcon from 'assets/delete.svg';
import HelpIcon from 'assets/help_grey.svg';

import Button from 'components/common/Button';

const credTypeOptions = [
  { label: 'Other', value: 'other' },
  { label: 'Amazon Web Services', value: 'AWS' },
];

const customStyles = {
  menu: (provided, state) => ({ ...provided, marginTop: '1px' }),
};

export const NewCredentialModalContent = (props) => {
  return (
    <div className="mt-4">
      <div className="text-gray-800 text-2xl font-bold mb-2 ml-2 flex items-center">
        <span>New Credential</span>{' '}
        <div className="ml-6 relative new-seed-tooltip-parent">
          <img src={HelpIcon} width="30" height="30" />
          <span className="w-64 font-medium bg-secondary-active text-white absolute new-seed-tooltip-child text-sm border border-gray-300 px-2 py-2 rounded-sm">
            Info for new credential
          </span>
        </div>
      </div>
      <div className="text-md">
        <div className="flex  flex-wrap w-full mt-8">
          <div className="w-3/12">Type</div>
          <div className="pl-3 w-9/12">
            <Select
              // inputValue={defaultValue}
              styles={customStyles}
              options={credTypeOptions}
              value={props.addProviderType}
              isSearchable={false}
              name="addProviderType"
              onChange={props.onChangeSelect}
              placeholder="Select Provider Type"
              // defaultValue={defaultValue}
              // defaultInputValue={defaultValue}
            />
          </div>
        </div>

        <div className="mt-20 text-right">
          <div className="flex items-center justify-between">
            <div className="text-right w-full">
              <Button
                intent="primary"
                // showSpinner={true}
                type="button"
                extendClass="text-md"
                // onClick={() => {
                //   setState((draft) => {
                //     draft.toggleAddProvider = true;
                //   });
                // }}
                // loading={sendUserInviteTeamState.loading ? true : false}
                //   disable={userLoginState.loading ? false : isSubmitting}
              >
                Cancel
              </Button>
              <Button
                intent="primary"
                // showSpinner={true}
                type="button"
                extendClass="ml-2 text-md"
                // onClick={() => {
                //   setState((draft) => {
                //     draft.toggleAddProvider = true;
                //   });
                // }}
                // loading={sendUserInviteTeamState.loading ? true : false}
                //   disable={userLoginState.loading ? false : isSubmitting}
              >
                Authenticate
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
